import React, { useEffect, useState } from "react"
import { Text, View, StyleSheet } from "react-native"
import { store } from "../../store/store"

import { clearCartData } from "../../utils/services/oms/OMSCartUtils";
import { getCurrentLocation } from "../../utils/services/locations/CurrentLocation";
import { selectedLocationForDashboard } from "../../utils/services/subject-behaviour/CommonRxjsService";
import { MoengageEvents, trackMoengageEvents } from "../../utils/services/webapp-services/MoengageUtils";

import { PrimaryCTA } from "../../utils/widgets/CommonCTA";
import { CommonLocationHeader } from "../../utils/widgets/CommonWidget/CommonHeader";

import { ScreenRoute } from "../../utils/constants/ScreenRouteConstant";

import AppTheme from "../../AppTheme"
import Lottie from "lottie-react-web"
import OmsStyles from "../../OmsStyle";

import location_animation from '../../assets/animation/location.json';
import ModalContent from "../../utils/constants/ModalContentConstant";

import CommonBottomSheet from "../../utils/modals/CommonBottomSheet";
import LocationSelectionBottomSheet from "../../utils/modals/LocationBottomSheet";

import * as Redux from "../../utils/services/redux/commonRedux"
import * as CommonUtils from '../../utils/services/CommonUtils';

const FetchOMSLocation = (props) => {

    const reduxState = store.getState()
    const isUserLoggedIn = reduxState.isUserLogin ? true : false

    const [showLocationBottomSheet, setLocationModal] = useState(true)
    const [blockedLocationModal, setBlockedLocationModal] = useState(false)

    function getUserCurrentLocation() {
        getCurrentLocation(isUserLoggedIn, showBlockedLocationModal).
            then((currentLocation: any) => {
                if (currentLocation) {
                    onLocationSelection(currentLocation)
                }
            })
    }

    function onLocationSelection(location) {
        let eventParams = { pid: location['pid'] }
        trackMoengageEvents(MoengageEvents.delivery_location_selected, eventParams)
        if (location['coordinates']) {
            eventParams['latLng'] = location['coordinates']
        } else if (location['location']) {
            let coordinates = location['location'].split(',')
            location['coordinates'] = { latitude: coordinates[0], longitude: coordinates[1] }
            eventParams['latLng'] = { latitude: coordinates[0], longitude: coordinates[1] }
        }
        trackMoengageEvents(MoengageEvents.oms_delivery_address_select, eventParams)
        const reduxState: any = store.getState();
        let clearCart = false
        if (reduxState.selectedLocation &&
            CommonUtils.isObjectNotEmpty(reduxState.selectedLocation)) {
            const selectedLocation = reduxState.selectedLocation
            if (location['aid'] != selectedLocation['aid']) {
                Redux.updateChemistData({});
                clearCart = true
            }
        } else clearCart = true
        if (clearCart) clearCartData()
        Redux.updateUserSelectedLocationToRedux(location)
        selectedLocationForDashboard.setSelectedLocation(location)
        props.navigation.replace(ScreenRoute.list_pharmacy, { selectedLocation: location })
    }

    const searchLocation = () => {
        props.navigation.navigate(ScreenRoute.search_locality)
    }

    const addNewAddress = () => {
        props.navigation.navigate(ScreenRoute.upsert_user_address)
    }

    const closeLocationModal = () => {
        setLocationModal(false)
    }

    const setLocationBottomSheet = () => {
        setLocationModal(true)
    }

    const showBlockedLocationModal = () => {
        setBlockedLocationModal(true)
    }

    const closeBlockedLocationModal = () => {
        setBlockedLocationModal(false)
    }

    useEffect(() => {
        if (store.getState().isUserLogin ||
            CommonUtils.isGuestTokenValid()) {
            setLocationBottomSheet()
        }
    }, [])



    return (

        <View style={{ flex: 1, width: AppTheme.appWidth }}>

            <CommonLocationHeader
                navigation={props.navigation}
                title={'Select location'}
                showLocationModal={true}
                onClickBottomChevron={setLocationBottomSheet}
                hideCart={true}
                cartNavigation={() => props.navigation.navigate(ScreenRoute.review_oms_order)} />

            {/* <CommonBottomSheet key={'blocked location'}
                action={searchLocation}
                modalData={ModalContent.BlockedLocation}
                showBottomSheet={blockedLocationAcess.active}
                setBottomSheet={setBlockedLocationAcess} /> */}

            <View style={{
                alignItems: 'center', width: AppTheme.appWidth,
                marginTop: AppTheme.appHeight * 0.3
            }}><Lottie options={{ animationData: location_animation }}
                width={AppTheme.appWidth - 128} /></View>

            <View style={styles.selectContainer}>
                <Text style={[OmsStyles.text16b, { marginBottom: 16 }]}>
                    Select your current location</Text>
                <PrimaryCTA
                    text={'Add Location'}
                    width={AppTheme.appWidth - 48}
                    onPress={() => { setLocationBottomSheet() }} />
            </View>

            <LocationSelectionBottomSheet
                fromReviewOrder={false}
                isUserLoggedIn={isUserLoggedIn}
                showLocationModal={showLocationBottomSheet}
                addAddress={addNewAddress}
                closeModal={closeLocationModal}
                searchLocation={searchLocation}
                onSelectSavedLocation={onLocationSelection}
                getUserCurrentLocation={getUserCurrentLocation} />

            <CommonBottomSheet key={'blocked location'}
                showModal={blockedLocationModal}
                modalData={ModalContent.BlockedLocation}
                closeModal={closeBlockedLocationModal}
                primaryAction={searchLocation} />

        </View>
    )
}

export default FetchOMSLocation;

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({

    inputContainer: {
        backgroundColor: AppTheme.color.background, borderRadius: 8,
        paddingVertical: 10, paddingHorizontal: 16, marginVertical: 24
    },
    modalView: {
        backgroundColor: AppTheme.color.white, paddingVertical: 16,
        borderTopLeftRadius: 12, borderTopRightRadius: 12,
    },

    selectInput: {
        flexGrow: 2,
        color: '#676869',
        paddingLeft: 8
    },

    selectLocText: {
        color: AppTheme.color.primary,
        textAlign: 'left',
        fontSize: 14,
        fontWeight: '600',
    },
    locationHead: { height: 10, width: 15 },
    selectContainer: {
        color: AppTheme.color.black,
        textAlign: 'center',
        fontSize: 16,
        letterSpacing: 0,
        opacity: 1,
        marginTop: 31,
    },
    selectBtn: {
        color: AppTheme.color.white,
        textAlign: 'center',
        fontSize: 14,
        letterSpacing: 0,
        opacity: 1,
        backgroundColor: AppTheme.color.primary,
        borderRadius: 48,
        paddingVertical: 14,
        width: AppTheme.appWidth - 32,
        marginTop: 16,
        margin: 'auto',

    },

    view: {
        justifyContent: 'flex-end',
        margin: 'auto',
        width: AppTheme.appWidth,
        // background: AppTheme.color.white
    },
}))